import React, { Component } from "react";
import { BsStar, BsFillStarFill } from "react-icons/bs";
import { ProductSingleProductView } from "./ProductSingleProductView";
import {
  Form,
  Button,
  Table,
  Card,
  OverlayTrigger,
  Tooltip,
  Toast,
  ToastContainer,
} from "react-bootstrap";
import CartContext from "./CartContext";

export default class ProductCard extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      qty: "1",
      pieceCount: "1",
      showSingleView: false,
      justAdded: false,
      showToast: false,
      favPopped: false,
      lastAction: "",
    };
  }

  // ---------- helpers ----------
  toNumber = (v, fallback = 0) => {
    const n = parseFloat(v);
    return Number.isFinite(n) ? n : fallback;
  };

  formatCurrency = (n) => {
    const { storeSettings } = this.context;
    const locale = storeSettings?.defaultLocale || "en-IN";
    const currency = storeSettings?.defaultCurrency || "INR";
    return Number(n).toLocaleString(locale, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 1,
      style: "currency",
      currency,
    });
  };

  getDiscounted = (mrp, discountPct) => {
    const m = this.toNumber(mrp);
    const d = this.toNumber(discountPct);
    return Math.round(m - (m * d) / 100);
  };

  getImageUrl = (prod) => {
    const { store } = this.context;
    if (!prod) return "";
    if (prod.imgFileName === null) return ""; // nothing if null
    if (prod.imgFileName === "") return "/placeholder.png";

    const base =
      (store?.storageBlobUrl || "") + (store?.storageBlobContainerName || "");
    const token = store?.storageSasToken || "";
    return `${base}/images/${prod.imgFileName}${token}`;
  };

  // ---------- actions ----------
  addToCartSubmit = async () => {
    const {
      modeOfSale,
      selectedPOS,
      addToPOSCart,
      forceUpdateCartView,
      storeSettings,
    } = this.context;

    const qty = this.toNumber(this.state.qty, 1);
    const pieceCount = this.toNumber(this.state.pieceCount, 1);

    if (qty <= 0 || pieceCount <= 0) {
      this.setState({ showToast: true, lastAction: "Invalid" });
      return;
    }

    const prod = this.props.prod || {};
    const variantType = prod.productVariantType;

    // requested qty for backend check
    const requestedQty = variantType === 3 ? pieceCount : qty;

    // If validateStockOnPos === true → skip backend validation
    const validation = storeSettings?.validateStockOnPos === true;

    if (validation) {
      const productId = encodeURIComponent(prod.id || "");
      const url = `${
        process.env.REACT_APP_API
      }Product/CheckStock?productId=${productId}&qty=${encodeURIComponent(
        requestedQty
      )}`;

      try {
        const res = await fetch(url, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });

        if (!res.ok) {
          console.error("CheckStock failed", res.status, await res.text());
          this.setState({ showToast: true, lastAction: "OutOfStock" });
          return;
        }

        const data = await res.json();

        if (!data || data.ok === false) {
          this.setState({ showToast: true, lastAction: "OutOfStock" });
          return;
        }
      } catch (err) {
        console.error("Stock check exception:", err);
        this.setState({ showToast: true, lastAction: "OutOfStock" });
        return;
      }
    }

    // --- proceed to add ---
    if (modeOfSale === "TableOrder") {
      this.props.AddRestaurantTableOrderItem?.({
        prod: this.props.prod,
        qty,
      });
      this.flashAdded("Added");
      return;
    }

    const added = addToPOSCart(selectedPOS, {
      prod: this.props.prod,
      qty,
      pieceCount,
    });

    this.setState({
      showToast: true,
      lastAction: added === false ? "Updated" : "Added",
    });

    if (added !== false) {
      this.flashAdded("Added");
      forceUpdateCartView?.();
    }
  };

  flashAdded(action) {
    this.setState({ justAdded: true, lastAction: action });
    if (this.justAddedTimer) clearTimeout(this.justAddedTimer);
    this.justAddedTimer = setTimeout(
      () => this.setState({ justAdded: false }),
      900
    );
  }

  OpenSingleView = () => this.setState({ showSingleView: true });
  editModalClose = () =>
    this.setState({ showSingleView: false }, () =>
      this.context.forceUpdateCartView?.()
    );

  IsAlreadyInFavList = (prodId) => {
    const ids = this.context.wishListProductIds || [];
    return ids.some((f) => f.prodId === prodId);
  };

  toggleFav = () => {
    const { prod } = this.props;
    this.context.AddToWishList(
      prod,
      (this.context.wishListProductIds?.length || 0) + 1
    );
    this.setState({ favPopped: true });
    if (this.favTimer) clearTimeout(this.favTimer);
    this.favTimer = setTimeout(() => this.setState({ favPopped: false }), 180);
  };

  GetProductNameDetailed = (prod) => {
    let result = prod?.name || "";
    if (prod?.hsncode) result += ` HSNCode: ${prod.hsncode}`;
    if (prod?.batchId) {
      result +=
        window.location.hostname === "sharoffsteel-pos.elasticcart.com"
          ? ` CoilId: ${prod.batchId}`
          : ` BatchId: ${prod.batchId}`;
    }
    if (prod?.qualityId) {
      result +=
        window.location.hostname === "sharoffsteel-pos.elasticcart.com"
          ? ` Test Report No: ${prod.qualityId}`
          : ` QualityId: ${prod.qualityId}`;
    }
    return result;
  };

  // ---------- renders ----------
  renderPriceBlock = (prod, alignCenter = true) => {
    const mrp = this.toNumber(prod?.mrp);
    const hasDiscount = this.toNumber(prod?.discount) > 0;
    const discounted = hasDiscount
      ? this.getDiscounted(mrp, prod.discount)
      : mrp;
    const savings = hasDiscount ? mrp - discounted : 0;

    return (
      <div style={{ textAlign: alignCenter ? "center" : "left" }}>
        {hasDiscount ? (
          <>
            <div style={{ fontSize: 12, opacity: 0.8 }}>
              <b style={{ fontSize: 16 }}>{this.formatCurrency(discounted)}</b>
              &nbsp;&nbsp;MRP:&nbsp;<s>{this.formatCurrency(mrp)}</s>
            </div>
            {/* <div style={{ fontSize: 16 }}>
              <b>{this.formatCurrency(discounted)}</b>
            </div> */}
            <div style={{ fontSize: 10, color: "green" }}>
              You save {this.formatCurrency(savings)} ({prod.discount}%)
            </div>
          </>
        ) : (
          <div style={{ fontSize: 16 }}>
            <b>{this.formatCurrency(mrp)}</b>
          </div>
        )}
      </div>
    );
  };

  renderImage = (prod, isCircle = false, size = "100%") => {
    if (!prod?.imgFileName) {
      return <></>; // nothing when image is missing
    }

    const resolvedSize = typeof size === "number" ? `${size}px` : size;
    const src = this.getImageUrl(prod);

    return (
      <img
        src={src}
        alt={prod?.name || "Product image"}
        loading="lazy"
        onClick={this.OpenSingleView}
        style={{
          cursor: "pointer",
          width: resolvedSize,
          height: resolvedSize,
          borderRadius: isCircle ? "9999px" : "8px",
          objectFit: "cover",
        }}
        onError={(e) => {
          // if the actual image fails to load → hide it
          e.target.style.display = "none";
        }}
      />
    );
  };

  render() {
    const { prod } = this.props;
    const { productView, searchBorderColor } = this.context;
    const isDesktop = window.innerWidth >= 900;

    const addDisabled = this.state.justAdded;
    const addLabel = this.state.justAdded ? "✔ Added" : "+ Add";

    return (
      <div className="m-0 p-0 border-0" tabIndex={0}>
        {/* Single View Modal */}
        {this.state.showSingleView && (
          <ProductSingleProductView
            show={this.state.showSingleView}
            onHide={this.editModalClose}
            prod={prod}
            AddRestaurantTableOrderItem={this.props.AddRestaurantTableOrderItem}
          />
        )}

        {/* Toast */}
        <ToastContainer position="top-end" className="p-2">
          <Toast
            bg="light"
            show={this.state.showToast}
            onClose={() => this.setState({ showToast: false })}
            delay={900}
            autohide
          >
            <Toast.Body style={{ fontSize: 12 }}>
              <b>{prod?.name}</b> —{" "}
              {this.state.lastAction === "Added"
                ? "Added to cart!"
                : this.state.lastAction === "Updated"
                ? "Updated in cart!"
                : this.state.lastAction === "OutOfStock"
                ? "Not enough stock."
                : "Invalid quantity"}
            </Toast.Body>
          </Toast>
        </ToastContainer>

        {/* Desktop vs Mobile rendering */}
        <Form className="m-0 p-0 border-0">
          <Form.Group className="m-0 p-0">
            {isDesktop ? (
              <>
                {productView === "grid" ? (
                  // GRID VIEW
                  <Card style={{ width: "100%" }} className="border-0">
                    {this.renderImage(prod, false)}
                    <Card.Body className="p-2 m-0">
                      <Card.Text className="text-center p-0 m-0">
                        <h6
                          style={{ cursor: "pointer" }}
                          onClick={this.OpenSingleView}
                        >
                          {this.GetProductNameDetailed(prod)}
                        </h6>
                        {this.renderPriceBlock(prod)}
                      </Card.Text>

                      <div className="d-flex gap-2">
                        <Button
                          className="flex-grow-1"
                          style={{
                            backgroundColor: addDisabled ? "#b2f5ea" : "cyan",
                            color: "black",
                            transition: "transform .05s ease",
                            transform: addDisabled ? "scale(0.98)" : "scale(1)",
                          }}
                          onClick={this.addToCartSubmit}
                          disabled={addDisabled}
                        >
                          {addLabel}
                        </Button>

                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip>
                              {this.IsAlreadyInFavList(prod?.id)
                                ? "Remove from Favorites"
                                : "Add to Favorites"}
                            </Tooltip>
                          }
                        >
                          <Button
                            className="bg-white text-success border-0"
                            onClick={this.toggleFav}
                            style={{
                              width: 42,
                              transition: "transform .18s",
                              transform: this.state.favPopped
                                ? "scale(1.15)"
                                : "scale(1)",
                            }}
                          >
                            {this.IsAlreadyInFavList(prod?.id) ? (
                              <BsFillStarFill
                                size="20"
                                style={{ color: "red" }}
                              />
                            ) : (
                              <BsStar />
                            )}
                          </Button>
                        </OverlayTrigger>
                      </div>
                    </Card.Body>
                  </Card>
                ) : (
                  // LIST VIEW
                  <Table
                    className="m-0 p-0"
                    size="sm"
                    style={{ tableLayout: "fixed" }}
                  >
                    <tbody>
                      <tr>
                        <td width="6%" className="text-center">
                          {this.renderImage(prod, true, ".65cm")}
                        </td>
                        <td width="44%" className="text-start">
                          <label
                            style={{ cursor: "pointer" }}
                            onClick={this.OpenSingleView}
                          >
                            <div>
                              <b>{this.GetProductNameDetailed(prod)}</b>
                              <br />
                              {prod?.sku ? (
                                <>
                                  <span className="text-primary">
                                    SKU : {prod?.sku}
                                  </span>
                                </>
                              ) : (
                                <></>
                              )}
                              {window.location.hostname ===
                              "sharoffsteel-pos.elasticcart.com" ? (
                                <></>
                              ) : (
                                <>
                                  <small className="text-danger">
                                    {prod?.productVariantType === 3
                                      ? ` [Stock PC: ${prod?.pieceCount}]`
                                      : ` [Stock: ${prod?.inStockQty}]`}
                                  </small>
                                </>
                              )}
                            </div>
                          </label>
                        </td>
                        <td width="22%" className="text-center">
                          {window.location.hostname ===
                          "sharoffsteel-pos.elasticcart.com" ? (
                            <>
                              <span className="text-black fs-5">
                                {prod?.productVariantType === 3 ? (
                                  <>
                                    PC: {prod?.pieceCount.toFixed(0)}
                                    <br /> MT: {prod?.inStockQty?.toFixed(2)}
                                  </>
                                ) : (
                                  <></>
                                )}
                              </span>
                            </>
                          ) : (
                            <>{this.renderPriceBlock(prod)}</>
                          )}
                        </td>
                        <td width="28%" className="text-end">
                          <div className="d-flex gap-2 justify-content-end">
                            <Button
                              onClick={this.addToCartSubmit}
                              style={{
                                backgroundColor: addDisabled
                                  ? "#b2f5ea"
                                  : searchBorderColor,
                                color: "black",
                                minWidth: 96,
                              }}
                              disabled={addDisabled}
                            >
                              <b>{addLabel}</b>
                            </Button>
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip>
                                  {this.IsAlreadyInFavList(prod?.id)
                                    ? "Remove from Favorites"
                                    : "Add to Favorites"}
                                </Tooltip>
                              }
                            >
                              <Button
                                className="bg-white text-success border-0"
                                onClick={this.toggleFav}
                                style={{
                                  transition: "transform .18s",
                                  transform: this.state.favPopped
                                    ? "scale(1.15)"
                                    : "scale(1)",
                                }}
                              >
                                {this.IsAlreadyInFavList(prod?.id) ? (
                                  <BsFillStarFill
                                    size="20"
                                    style={{ color: "red" }}
                                  />
                                ) : (
                                  <BsStar />
                                )}
                              </Button>
                            </OverlayTrigger>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                )}
              </>
            ) : (
              // MOBILE VIEW
              <Table
                className="m-0 p-0"
                size="sm"
                style={{ tableLayout: "fixed" }}
              >
                <tbody>
                  <tr>
                    <td width="10%">{this.renderImage(prod, true, ".7cm")}</td>
                    <td width="45%" className="text-start">
                      <label
                        style={{
                          cursor: "pointer",
                          fontSize: "12px",
                          color: "black",
                        }}
                        onClick={this.OpenSingleView}
                      >
                        <div>
                          {prod?.name}
                          <br />
                          SKU : {prod?.sku}
                        </div>
                      </label>
                    </td>
                    <td width="25%">{this.renderPriceBlock(prod, false)}</td>
                    <td width="20%">
                      <div className="d-flex gap-2">
                        <Button
                          className="w-100 text-dark"
                          onClick={this.addToCartSubmit}
                          style={{
                            backgroundColor: addDisabled ? "#b2f5ea" : "cyan",
                          }}
                          disabled={addDisabled}
                        >
                          {addLabel}
                        </Button>
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip>
                              {this.IsAlreadyInFavList(prod?.id)
                                ? "Remove from Favorites"
                                : "Add to Favorites"}
                            </Tooltip>
                          }
                        >
                          <Button
                            className="bg-white text-success border-0"
                            onClick={this.toggleFav}
                            style={{
                              transition: "transform .18s",
                              transform: this.state.favPopped
                                ? "scale(1.15)"
                                : "scale(1)",
                            }}
                          >
                            {this.IsAlreadyInFavList(prod?.id) ? (
                              <BsFillStarFill
                                size="18"
                                style={{ color: "red" }}
                              />
                            ) : (
                              <BsStar />
                            )}
                          </Button>
                        </OverlayTrigger>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </Table>
            )}
          </Form.Group>
        </Form>
      </div>
    );
  }
}
